export enum EditMode {
  Split = "split",
  WallPlanner = "wallPlanner",
  Select = "select",
  DraftBulkOperation = "draftBulkOperation",
  Disabled = "disabled"
}
